import { CODE_OK } from '@/apis/code'
import type { CommonResponse } from '@/apis/api'
import {
  getUserProfile,
  saveUser,
  currentUser,
  currentUserHandle,
  DEMO_ID,
  type AccountDTO
} from '@/composables/user/users'

let bootstrapped = false

export default defineNuxtPlugin(async () => {
  if (bootstrapped) return
  bootstrapped = true

  if (currentUserHandle.value !== DEMO_ID) return

  const token = currentUser.value?.token?.accessToken
  if (!token || token === '<DEMO_KEY>') return

  const { data, error } = await getUserProfile()
  if (error.value) return

  const resData = data as unknown as Ref<CommonResponse<AccountDTO>>
  if (resData.value?.code === CODE_OK && resData.value?.data?.user?.id) {
    saveUser(resData.value.data)
  }
})
